export enum ChangeRequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export enum ChangeType {
  Create = 1,
  Update = 2,
  Delete = 3,
}

export enum EntityType {
  IndividualMember = 1,
  Institution = 2,
}

export interface ChangeRequest {
  id: string;
  userId: string;
  entityType: EntityType;
  entityId: string;
  fieldName: string;
  oldValue?: string;
  newValue?: string;
  status: ChangeRequestStatus;
  requestedAt: string;
  reviewedAt?: string;
  reviewedBy?: string;
  rejectionReason?: string;
  changeType: ChangeType;
  userEmail?: string;
  currentValue?: string;
}

export interface ChangeRequestReview {
  changeRequestId: string;
  approve: boolean;
  rejectionReason?: string;
}

export interface ChangeRequestFilters {
  entityType?: EntityType;
  status?: ChangeRequestStatus;
  userId?: string;
}
